export var ExperienceTypes = /*#__PURE__*/function (ExperienceTypes) {
  ExperienceTypes["Load"] = "load";
  ExperienceTypes["Experience"] = "experience";
  ExperienceTypes["Operation"] = "operation";
  return ExperienceTypes;
}({});
export var ExperiencePerformanceTypes = /*#__PURE__*/function (ExperiencePerformanceTypes) {
  ExperiencePerformanceTypes["PageLoad"] = "page-load";
  ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
  ExperiencePerformanceTypes["InlineResult"] = "inline-result";
  ExperiencePerformanceTypes["Custom"] = "custom";
  return ExperiencePerformanceTypes;
}({});